/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';

import AppTable from 'components/appTable';
import SearchBox from 'components/form/searchBox';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import PaginationApp from 'components/pagination';
import { useActions } from 'common/hooks/useActions';
import { menuCustomizationArray } from 'common/enums';
import Value from 'components/value';
import { formatDateTime } from 'common/helpers/format';

import * as S from './styles';
import * as T from 'common/types';
import { Link } from 'react-router-dom';

interface IProps {
  menuList: { list: T.Pages.CafeteriaListItem[]; totalPages: number };
  loading: boolean;
}

export default function CafeteriaMenuManagementTable({ menuList, loading }: IProps) {
  const { menuCustomizationListRequestAction } = useActions();
  const [meta, setMeta] = useState({
    page: 1,
    page_size: 10,
    keyword: '',
    type: ''
  });

  const fetchData = () => {
    menuCustomizationListRequestAction(meta);
  };

  useEffect(() => {
    fetchData();
  }, [meta]);

  const handleChangePage = (page: number) => {
    setMeta({ ...meta, page });
  };

  const handleChangeTake = (page_size: number) => {
    setMeta({ ...meta, page_size });
  };

  const renderCategoryName = (cat: string) => {
    let newText: string = '';
    // -- //
    // eslint-disable-next-line array-callback-return
    menuCustomizationArray.map((item: any) => {
      if (item.id === cat) newText = item.title;
    });
    return newText;
  };

  const handleFilter = (field: string, val: string | number) => {
    setMeta({ ...meta, page: 1, [field]: val });
  };

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          <SearchBox onChange={(e) => handleFilter('keyword', e)} placeholder="Search" value={meta.keyword} />
        </S.Head>
        <Gap size="20px" />
        <AppTable
          headers={[
            { id: 1, key: 'id', title: 'ID', dir: 'left', width: 84 },
            { id: 3, key: 'title', title: 'Title', dir: 'left' },
            { id: 2, key: 'type', title: 'Type', dir: 'left', width: 130 },
            { id: 4, key: 'CreatedAt', title: 'CreatedAt', dir: 'left', width: 156 },
            { id: 4, key: 'UpdatedAt', title: 'UpdatedAt', dir: 'left', width: 156 },
            { id: 5, key: 'status', title: 'Status', dir: 'left', width: 120 },
            { id: 7, key: 'edit', title: 'Edit', type: 'actions', width: 72 }
          ]}
          style={{ minWidth: 'auto' }}
          data={menuList?.list}
          loading={loading}
          altanfeethiFields={{
            id: (item: T.Pages.MenuCustomization) => <S.Div className="text-left">{item?.id}</S.Div>,
            title: (item: T.Pages.MenuCustomization) => <S.Div className="text-left captal">{item?.title}</S.Div>,
            type: (item: T.Pages.MenuCustomization) => (
              <S.Div className="text-left">{renderCategoryName(item?.optionType)}</S.Div>
            ),
            CreatedAt: (item: T.Pages.MenuCustomization) => (
              <S.Div className="text-left">
                <Value mono>{formatDateTime(item?.createdAt)}</Value>
              </S.Div>
            ),
            UpdatedAt: (item: T.Pages.MenuCustomization) => (
              <S.Div className="text-left">
                <Value mono>{formatDateTime(item?.UpdatedAt)}</Value>
              </S.Div>
            ),
            status: (item: T.Pages.MenuCustomization) => (
              <S.Div
                className={`text-left ${item?.isActive ? 'active' : 'inactive'}`}
                style={{ color: item?.isActive ? '#1DBAAF' : '#FF6464' }}
              >
                {item?.isActive ? 'Active' : 'Inactive'}
              </S.Div>
            ),
            edit: (item: T.Pages.MenuCustomization) => (
              <S.Div style={{ cursor: 'pointer' }}>
                <Link to={`/panel/cafeteria/customizations/${item?.id}`}>
                  <ReactSVG
                    src="/icons/stroke/pen-card.svg"
                    beforeInjection={(svg) => {
                      svg.setAttribute('stroke', `#8A93AC`);
                    }}
                  />
                </Link>
              </S.Div>
            )
          }}
        />
      </PanelBoxLayout>
      {menuList?.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * menuList.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={menuList.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangeTake}
        />
      ) : (
        <></>
      )}
    </S.Content>
  );
}
